<template>
  <div
    class="w-full text-white font-normal flex flex-col md:flex-row md:justify-between"
  >
    <div class="">
      <PremiumPrice
        :price="billingPeriod === 'annual' ? 399 : 99"
        :billingPeriod="billingPeriod"
      />

          <ChargbeeModal
            plan-id="iwlca-recruits-premium-annual"
            :checkout-data="checkoutJsData"
            redirect-to="/activity/everyone/all/welcome/iwlca-recruits-premium-annual"
          >
            <Button 
              slot="button"
              slot-scope="props"
              text="Upgrade to Pro"
              class="mt-4 mb-6 md:inline-flex"
              color="blue"
              icon="sr-2 sr-v2-arrow-right-circle origin-center translate-y-1"
              :icon-options="{customClasses: 'transform -rotate-90'}"
              textColor="ds-text-xl text-white"
              @click.native.prevent="purchaseProduct(props.startCheckout)"
              emphasis="high"
            />
          </ChargbeeModal>
    </div>

    <div
      class="flex-1"
      :class="{
        'border border-solid border-gray-300 border-l-0 border-r-0 border-b-0 border-t-1 pt-6': isMobile,
        'border border-solid border-l-1 border-r-0 border-b-0 border-t-0 pt-0 pl-6 ml-6': !isMobile,
      }"
    >
      <div class="text-white ds-text-2xl font-bold md:mt-2 mb-4">
        {{ copy.footer }}
        <p
          class="font-normal ds-text-base text-gray-100 mt-4"
          v-html="copy.footerDesc"
        ></p>
      </div>
      <PremiumInfoBox
        v-for="(box, i, x) of enhancedInfoBoxed"
        :data-qa="`premium_info_box_${x}`"
        :label="box.label"
        :desc="box.desc"
        :key="i"
      />
    </div>
  </div>
</template>

<script>
import PremiumPrice from "./PricingPremiumPrice";
import PremiumInfoBox from "./PricingPremiumInfoBox";
import { Button } from "@sportsrecruits/playbook";
import tracking from "@/components/Pricing/utils/tracking";
import ChargbeeModal from "@/srui/components/ChargbeeModal";
import { mapState } from "vuex";

export default {
  components: {
    PremiumPrice,
    PremiumInfoBox,
    Button,
    ChargbeeModal,
  },
  data: () => ({
    billingPeriod: "annual",
    checkoutJsData: null,
    copy: {
      infoBoxes: {
        film: {
          label: "Access to Film from Top Events",
          desc:
            "Get in-platform access to event film from the <a href='https://www.iwlcarecruits.com/event-film-access' target='_blank'>IWLCA, Robinson Sports, STEPS and Summit events</a> you attend starting Summer 2021. This video will automatically be available in your account as soon as it\'s processed and will be viewable to College Coaches once published.",
        },
        collegeViews: {
          label: "College Views",
          desc:
            "Find out, in real-time, whenever a college has <a href='https://help.sportsrecruits.com/hc/en-us/articles/115005481246-Which-College-Coaches-Viewed-My-Profile-Transcript-Video-' target='_blank'>viewed your profile</a>, video or transcripts on the platform.",
        },
        messageSystem: {
          label: "Messaging System",
          desc:
            "Every college coach in the U.S. is immediately accessible via the <a href='https://help.sportsrecruits.com/hc/en-us/articles/214939263-What-s-the-Importance-of-the-SportsRecruits-Messaging-System-' target='_blank'>messaging system</a>. Easily communicate with any college coach and drive them directly to your profile.",
        },
      },
      cancel: "Cancel anytime with monthly payment option",
      footer: "Your Home for the Recruiting Process",
      footerDesc: "In addition to the profile, school search and video library, Pro gives you the ability to connect with any college coach in the country and track their engagement. You'll also get playlist tools to organize and share your video, plus access to game film from top events you attended."
    },
  }),
  computed: {
    ...mapState("pricing", ["rosterNeedsEnabled"]),
    isMobile() {
      return ["xs", "sm", "mobile"].includes(this.$mq);
    },
    enhancedInfoBoxed() {
      const { film, collegeViews, messageSystem } = this.copy.infoBoxes;
      const boxes = [film, collegeViews, messageSystem];
      if (this.rosterNeedsEnabled) {
        boxes.push({
          label: "Match Roster Needs in One Click",
          desc:
            "In one click, access every school with open roster spots that <a href='https://help.sportsrecruits.com/hc/en-us/articles/12756494387725-How-to-Filter-through-Roster-Needs' target='_blank'>match your profile.</a> Layer with other filters to find schools that fit your athletic, academic, and social criteria.",
        });
      }
      return boxes;
    },
  },
  methods: {
    handleBillingPeriodChange(val) {
      this.billingPeriod = val;
    },
    purchaseProduct(callback) {
      this.plan = "Premium";
      
      tracking.purchase({
        event: "clicked_purchase_plan_cta",
        cta_location: this.plan,
      });
      
      return callback();
    },
  },
  beforeMount() {
    this.checkoutJsData = window.pricing.checkoutJsData;
  }
};
</script>

<style>
</style>
